import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'callBackFunction',
})
export class CallBackFunctionPipe<T extends object> implements PipeTransform {
  transform(element: T, transformCallBack ?: (element, ...args) => T, ...args): T {
    if(transformCallBack){
      return transformCallBack(element, ...args);

    }else {
      return JSON.parse(JSON.stringify(element))
    }
  }
}
